import { DeliveryPointIntervalSearchResponse } from '@lentau/order/intervals/delivery/shared/interfaces';
import { checkEmptyFields } from '../utils';
import { EventProperties } from '@lentau/analytics/health-metrics/shared';

export function getIntervalsHandler(body: DeliveryPointIntervalSearchResponse): EventProperties {
  {
    const intervals = body.DeliveryPlannedIntervalList;

    const fields = [
      {
        fieldToCheck: intervals,
        errorName: 'intervalsIsEmpty',
      },
    ];

    return checkEmptyFields(fields); // there may be a custom validation like in cart-item-clear-handler.ts
  }
}
